var map = {
	"./img_1.jpg": 62996,
	"./img_2.jpg": 887,
	"./img_3.jpg": 20434,
	"./img_4.jpg": 56544,
	"./img_5.jpg": 88380,
	"./img_6.jpg": 64519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63214;